<template>
  <div>
    <van-sticky>
      <van-tabs class="title" v-model="tab" ref="tabRef" title-active-color="#1989fa" @change="onTabChange">
        <van-tab name="day" title="本日" />
        <van-tab name="week" title="本周" />
        <van-tab name="month" title="本月" />
        <van-tab name="custom">
          <template #title>
            <span @click="calendarShow"><van-icon name="notes-o" />自定义</span>
          </template>
        </van-tab>
      </van-tabs>
    </van-sticky>
    <!--员工业绩柱状图-->
    <div class="van-sidebar-item van-sidebar-item--select">员工业绩排行</div>
    <br />
    <ve-histogram :data="chartData"></ve-histogram>
    <!--员工业绩面板-->
    <van-collapse v-model="activeNames">
      <van-collapse-item v-for="(item, index) in empRankList" :key="index" :name="item.employeeName">
        <template #title>
          <div>
            <img v-if="index == 0" width="24px" class="emp-badge" src="@/assets/gold.png" />
            <img v-else-if="index == 1" width="24px" class="emp-badge" src="@/assets/silver.png" />
            <img v-else-if="index == 2" width="24px" class="emp-badge" src="@/assets/bronze.png" />
            <span v-else class="emp-num">{{ index + 1 }}</span>
            <span class="emp-name">{{ item.employeeName }}</span>
          </div>
        </template>
        <template #value>
          <span class="emp-amt-text">业绩</span><span class="emp-amt">：￥{{ item.salesAmount | AmtFormat }}</span>
        </template>
        <van-grid :column-num="3">
          <van-grid-item>
            <div class="tot-content">{{ item.salesRatio }}</div>
            <div class="tot-title">销售金额占比</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.salesQuantity | AmtFormat }}</div>
            <div class="tot-title">销售件数</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.orderCount | AmtFormat }}</div>
            <div class="tot-title">小票开单数</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.averageTransactionValue | AmtFormat }}</div>
            <div class="tot-title">客单价</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.jointRate }}</div>
            <div class="tot-title">连带率</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.topCount }}</div>
            <div class="tot-title">TOP次数</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.totalTarget | AmtFormat }}</div>
            <div class="tot-title">目标</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.dailyAchievementRate }}</div>
            <div class="tot-title">达成率</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.prestoreCount | AmtFormat }}</div>
            <div class="tot-title">预存笔数</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.prestoreAmount | AmtFormat }}</div>
            <div class="tot-title">预存金额</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.repurchaseCount | AmtFormat }}</div>
            <div class="tot-title">复购单数</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.repurchaseRate }}</div>
            <div class="tot-title">复购占比</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.newVipCount | AmtFormat }}</div>
            <div class="tot-title">新增会员数</div>
          </van-grid-item>
        </van-grid>
      </van-collapse-item>
    </van-collapse>
    <!--日期过滤-->
    <van-calendar v-model="dateShow" class="calendar" :min-date="minDate" :max-date="maxDate" type="range"
      @confirm="onDateConfirm" />
  </div>
</template>

<script>
import { reqEmployeeSales } from "@/api/board";

export default {
  name: "empRank",

  data() {
    return {
      tab: 'day',
      dateStr: '本日',

      dateShow: false,
      minDate: null,
      maxDate: null,

      chartData: {
        columns: ["员工", "销售额",],
        rows: [],
      },

      //员工
      empRankList: [],
      activeNames: [],

      //请求参数
      reqData: {
        startDate: null,
        endDate: null,
        pageNum: 1,
        pageSize: 30,
      },

    }
  },

  computed: {

  },

  created() {
    //初始化数据
    let nowDate = new Date();
    this.dateShow = false;
    this.minDate = new Date(this.$moment(nowDate).subtract(2, 'year').startOf('year').format());
    this.maxDate = nowDate;
    //获取跳转入参
    this.reqData.startDate = this.$route.params.startDate;
    this.reqData.endDate = this.$route.params.endDate;
    this.tab = this.$route.params.tab;
    this.dateStr = this.$route.params.dateStr;
    //获取员工数据
    this.getEmployeeSales();
  },

  mounted() {

  },

  methods: {
    //切换tab
    onTabChange(name) {
      //获取默认日期  this.$moment('20230102').format()
      let nowDate = new Date();
      if (name == 'day') {
        this.reqData.startDate = this.$moment(nowDate).format('YYYYMMDD');
        this.reqData.endDate = this.$moment(nowDate).format('YYYYMMDD');
        this.dateStr = '本日';
      } else if (name == 'week') {
        this.reqData.startDate = this.$moment(nowDate).startOf("isoWeek").format('YYYYMMDD');
        this.reqData.endDate = this.$moment(nowDate).endOf("isoWeek").format('YYYYMMDD');
        this.dateStr = '本周';
      } else if (name == 'month') {
        this.reqData.startDate = this.$moment(nowDate).startOf("month").format('YYYYMMDD');
        this.reqData.endDate = this.$moment(nowDate).endOf("month").format('YYYYMMDD');
        this.dateStr = '本月';
      }
      //获取员工数据
      this.getEmployeeSales();
    },
    //日期选择
    calendarShow() {
      this.dateShow = true;
    },
    //选择日期
    onDateConfirm(date) {
      this.dateShow = false;
      this.reqData.startDate = this.$moment(date[0]).format('YYYYMMDD');
      this.reqData.endDate = this.$moment(date[1]).format('YYYYMMDD');
      this.dateStr = this.$moment(date[0]).format('M.D') + "-" + this.$moment(date[1]).format('M.D');
      //获取员工数据
      this.getEmployeeSales();
    },
    //获取员工排行数据
    getEmployeeSales() {
      this.empRankList = [];
      this.chartData.rows = [];
      this.activeNames = [];
      //发出请求
      reqEmployeeSales(this.reqData).then((res) => {
        this.empRankList = res.data;
        //解析员工信息
        this.empRankList.forEach((item) => {
          this.chartData.rows.push({ "员工": item.employeeName, "销售额": item.salesAmount, });
          this.activeNames.push(item.employeeName);
        });
      });
    },
  },
}
</script>

<style scoped lang="less">
/deep/ .title .van-tabs__line {
  background-color: #1989FA;
}

/deep/ .van-calendar__day--start {
  background-color: #379bff;
}

/deep/ .van-calendar__day--middle {
  background-color: #c8dcff;
}

/deep/ .van-calendar__day--end {
  background-color: #379bff;
}

/deep/ .van-calendar__day--middle {
  color: #379bff;
}

/deep/ .calendar .van-button--danger {
  color: #fff;
  background-color: #379bff;
  border: 1px solid #379bff;
}

.emp-badge {
  position: absolute;
}

.emp-num {
  position: absolute;
  background: #969799;
  z-index: 9;
  left: 1.5rem;
  width: 5.333333vw;
  height: 5.333333vw;
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 3.2vw;
  color: white;
  -webkit-box-shadow: 0 0.533333vw 1.066667vw rgba(0, 0, 0, 0.2);
  box-shadow: 0 0.533333vw 1.066667vw rgba(0, 0, 0, 0.2);
}

.emp-name {
  position: absolute;
  left: 3rem;
  font-size: 1rem;
  color: #646566;
}

.emp-amt-text {
  font-size: 1rem;
  color: #646566;
}

.emp-amt {
  color: #ee0a24;
  font-size: 1rem;
}

.tot-title {
  font-size: 0.7rem;
  color: #646566;
}

.tot-content {
  font-size: 1rem;
  font-family: "Arial";
  color: #1e88e5;
}

/deep/ .van-collapse-item__content {
  padding: 0px 0px;
}
</style>


// WEBPACK FOOTER //
// src/view/board/empRank.vue